
<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
// import { ImagePreview } from 'vant'

const props = defineProps({
  html: String
})

const rich = ref(null)
const richHeight = ref(0)
const isOpen = ref(true)
const observer = ref(null)
// const images = ref([])
// const imgDom = ref([])

const copyHtml = computed(() => {
  const html = props.html
  /* eslint-disable */
  return html
    .replace(/<img([\s\w"-=\/\.:;]+)((?:(height="[^"]+")))/gi, "<img$1")
    .replace(/<img([\s\w"-=\/\.:;]+)((?:(width="[^"]+")))/gi, "<img$1")
    .replace(/<img([\s\w"-=\/\.:;]+)((?:(style="[^"]+")))/gi, "<img$1")
    .replace(/<img([\s\w"-=\/\.:;]+)((?:(alt="[^"]+")))/gi, "<img$1")
    .replace(/<img([\s\w"-=\/\.:;]+)/gi, '<img style="width: 100%;" $1')
  /* eslint-enable */
})

// function handleHtmlChange() {
//   nextTick(() => {
//     const myRich = rich.value
//     imgDom.value = myRich.querySelectorAll('img') || []
//     imgDom.value.forEach((dom, i) => {
//       images.value = [...images.value, dom.src]
//       console.log('🚀 ~ handleHtmlChange ~ images.value:', images.value)
//       dom.onclick = () => {
//         ImagePreview({
//           images: images.value,
//           startPosition: i,
//           closeable: true
//         })
//       }
//     })
//     richHeight.value = myRich?.offsetHeight
//   })
// }

// watch(
//   () => copyHtml.value,
//   handleHtmlChange,
//   { immediate: true }
// )

onMounted(() => {
  observer.value = new IntersectionObserver(changes => {
    if (changes[0].isIntersecting) {
      richHeight.value = rich.value?.offsetHeight
    }
  })
  observer.value.observe(rich.value)
})

onBeforeUnmount(() => {
  observer.value.unobserve(rich.value)
})
</script>

<template>
  <div class="rich" :class="{ 'html-wrap': richHeight > 200 && !isOpen }">
    <div class="rich-wrap">
      <div ref="rich" v-safe-html="copyHtml" />
    </div>
    <div v-if="richHeight > 200" class="open-btn">
      <div @click.stop="isOpen = !isOpen">
        <span>{{ !isOpen ? "展开" : "收起" }}详情</span>
        <svg-icon
          name="more"
          :style="`font-size: 14px; margin-left: 5px;transform: rotate(${!isOpen ? '90deg' : '-90deg'})`"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
// scss
.rich {
  height: 100%;
  padding-top: 10px;
  box-sizing: border-box;
  .open-btn {
    line-height: 30px;
    text-align: center;
    .qxs-icon {
      transition: all 0.1s;
      margin-left: 5px;
    }
  }
  :deep(.rich-wrap) {
    img {
      max-width: 100% !important;
      height: auto;
    }
  }
}
.html-wrap {
  height: 200px;
  overflow: hidden;
  position: relative;
  .open-btn {
    height: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-image: linear-gradient(180deg, rgba(238, 238, 238, 0) 0, #fff 65%);
  }
}
</style>
